import React from 'react';
import { facts } from '../data/facts';
import '../styles/ProgressBar.css';

const ProgressBar = ({ completedFacts, currentFactIndex }) => {
  return (
    <div className="progress-bar">
      {facts.map((fact, index) => (
        <div
          key={index}
          className={`progress-segment ${
            completedFacts.includes(index) ? 'completed' : ''
          } ${index === currentFactIndex ? 'active' : ''}`}
          style={{
            backgroundColor: completedFacts.includes(index) ? fact.color : 'transparent',
            borderColor: fact.color,
          }}
        >
          <span className="progress-number">{index + 1}</span>
        </div>
      ))}
    </div>
  );
};

export default ProgressBar;
